import { Tabs, ScrollArea } from "@mantine/core";

/**
 * Horizontally-scrollable tab strip: stops a multi-tab list wrapping into ragged 2–3 row blocks on
 * phones. Drop-in replacement for `<Tabs.List>` — must be used inside a `<Tabs>` (the Tabs context
 * reaches the tabs through React context, not DOM position, so wrapping the list in a ScrollArea is
 * safe). Same children (`<Tabs.Tab>…`).
 */
export default function ScrollableTabsList({ children, ...listProps }) {
  return (
    <ScrollArea type="never" scrollbars="x" offsetScrollbars={false}>
      <Tabs.List style={{ flexWrap: "nowrap" }} {...listProps}>
        {children}
      </Tabs.List>
    </ScrollArea>
  );
}
